import React from 'react';
import { useI18n } from '../../hooks/useI18n';
import { UserPersona } from '../../types/cabinet.types';

import HeartHandshakeIcon from '@/assets/image/heart-handshake.svg?react';
import CalendarDaysIcon from '@/assets/image/calendar-days.svg?react';
import FileTextIcon from '@/assets/image/file-text.svg?react';
import UserCogIcon from '@/assets/image/user-cog.svg?react';
import CalendarPlus from '@/assets/image/calendar-plus.svg?react';

export type NavTab = 'consultations' | 'therapy' | 'visits' | 'services' | 'documents' | 'profile' | 'przeloz' | 'visit-summary' | 'diet_survey';

interface BottomNavbarProps {
  activeTab: NavTab;
  onChangeTab: (tab: NavTab) => void;
  persona: UserPersona;
  /** true якщо пацієнт є в wp_otylosc_patients (програма схуднення) */
  isWeightLoss?: boolean;
}

export const BottomNavbar: React.FC<BottomNavbarProps> = ({ activeTab, onChangeTab, persona, isWeightLoss }) => {
  const { t } = useI18n();

  

  // A-навігація показується якщо personaType = 'A' АБО якщо пацієнт є в програмі схуднення
  const isPersonaA = persona === 'A' || isWeightLoss === true;

  const tabs = isPersonaA
    ? [
        { id: 'therapy', label: t('nav_terapia'), icon: <HeartHandshakeIcon /> },
        { id: 'services', label: t('nav_uslugi'), icon: <CalendarDaysIcon /> },
        { id: 'documents', label: t('nav_doc'), icon: <FileTextIcon /> },
        { id: 'profile', label: t('nav_dane'), icon: <UserCogIcon /> }
      ]
    : [
        { id: 'services', label: t('nav_umow'), icon: <CalendarPlus /> },
        { id: 'consultations', label: t('nav_cons_short'), icon: <CalendarDaysIcon /> },
        { id: 'documents', label: t('nav_doc'), icon: <FileTextIcon /> },
        { id: 'profile', label: t('nav_dane'), icon: <UserCogIcon /> }
      ];


  return (
    <div className={`cab-bnav cab-bnav-persona-${persona}`}>
      {tabs.map((tab, idx) => (
        <button 
          key={tab.id}
          className={`cab-bnav-item ${activeTab === tab.id || (tab.id === 'therapy' && (activeTab === 'visits' || activeTab === 'visit-summary')) || (tab.id === 'consultations' && activeTab === 'visit-summary') ? 'active' : ''}`}
          onClick={() => onChangeTab(tab.id as NavTab)}
          data-tour={`nav-${idx + 1}`}
        >
          <div className="cab-bnav-ic">
            {tab.icon}
          </div>
          <span>{tab.label}</span>
        </button>
      ))}
      <style>{`
        .cab-bnav {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 80px;
          background: rgba(230, 214, 250, 0.85);
          backdrop-filter: blur(4px);
          -webkit-backdrop-filter: blur(4px);
          border-top: 1px solid #AB9CC9;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 16px;
          padding: 0 8px 12px;
          z-index: 40;
        }
        .cab-bnav-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 8px;
          background: none;
          border: none;
          height: 100%;
          flex: 1;
          cursor: pointer;
          color: #786798;
          transition: 0.2s;
          max-width: 90px;
        }
        .cab-bnav-item span {
          font-size: 12px;
          font-weight: 600;
          transition: 0.2s;
          line-height: 1.4em;
        }
        .cab-bnav-ic {
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #786798;
          transition: 0.2s;
        }
        .cab-bnav-ic svg {
          width: 100%;
          height: 100%;
          stroke: currentColor;
          fill: none;
        }
        .cab-bnav-ic svg path,
        .cab-bnav-ic svg rect,
        .cab-bnav-ic svg line,
        .cab-bnav-ic svg polyline,
        .cab-bnav-ic svg circle {
          stroke: currentColor;
        }
        .cab-bnav-item.active {
          color: #361777;
        }
        .cab-bnav-item.active .cab-bnav-ic {
          color: #361777;
        }
        
        @media (min-width: 1024px) {
          .cab-bnav {
            position: fixed;
            bottom: 24px;
            left: 50%;
            transform: translateX(-50%);
            width: calc(100% - 32px);
            max-width: 448px;
            height: 64px;
            background: #fff;
            border-radius: 20px;
            border-top: none;
            box-shadow: 0 10px 40px rgba(54, 23, 119, 0.12);
            padding: 0 8px;
            backdrop-filter: none;
          }
          .cab-bnav-item span {
            font-size: 10px;
          }
        }
      `}</style>
    </div>
  );
};

// Custom Services Icon (3D Cube) for B/C
const ServicesIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
    <path d="M3.27 6.96L12 12.01l8.73-5.05"/>
    <path d="M12 22.08V12"/>
  </svg>
);

